import axios, { AxiosError } from 'axios';

const API_BASE = '/origo/api';

const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  // Note: No withCredentials needed - using Bearer token authentication
});

// Request interceptor to add Bearer token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('origo_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to unwrap Fruster response format and handle errors
apiClient.interceptors.response.use(
  (response) => {
    // Fruster services return: { status, data, reqId, transactionId, ms, from }
    // We need to extract the nested 'data' field
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      response.data = response.data.data;
    }
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('origo_access_token');
      window.location.href = '/logga-in';
    }
    return Promise.reject(error);
  }
);

export async function apiGet<T>(endpoint: string, params?: Record<string, any>): Promise<T> {
  const { data } = await apiClient.get<T>(endpoint, { params });
  return data;
}

export async function apiPost<T>(endpoint: string, body: any): Promise<T> {
  const { data } = await apiClient.post<T>(endpoint, body);
  return data;
}

export async function apiPut<T>(endpoint: string, body: any): Promise<T> {
  const { data } = await apiClient.put<T>(endpoint, body);
  return data;
}

export async function apiDelete<T>(endpoint: string): Promise<T> {
  const { data } = await apiClient.delete<T>(endpoint);
  return data;
}

export async function apiPatch<T>(endpoint: string, body: any): Promise<T> {
  const { data } = await apiClient.patch<T>(endpoint, body);
  return data;
}
